module.exports = __webpack_public_path__ + "static/media/19.ee46d2ca.jpg";